export default __webpack_public_path__ + "src/assets/gol-logo.495bdcacb37fd343335085749faf7e15.png";